import { render } from "./ContactPage.vue?vue&type=template&id=cf77cc76&scoped=true"
const script = {}

import "./ContactPage.vue?vue&type=style&index=0&id=cf77cc76&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cf77cc76"]])

export default __exports__